import { Navigate } from 'react-router-dom';

/**
 * @deprecated This page is deprecated. Resellers (business customers) are now
 * managed through the unified Customers page at /app/customers.
 *
 * This component redirects to the customers page with the business type filter.
 */
export const ResellersPage = () => {
  // Redirect to unified customers page filtered by business type
  return <Navigate to="/app/customers?type=business" replace />;
};

// Keep ResellerList export for backwards compatibility, but mark as deprecated
/** @deprecated Use customer list with type=business filter instead */
export { ResellerList } from './list';
